/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { CSSProperties } from 'react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';

const MEDIUM_SIZE = '1.375rem';

export const uiButtonIconMediumWidth: CSSProperties = {
    minWidth: MEDIUM_SIZE,
};
export const uiButtonIconMediumHeight: CSSProperties = {
    height: MEDIUM_SIZE,
};
export const uiButtonIconMediumSize: CSSProperties = {
    ...uiButtonIconMediumWidth,
    ...uiButtonIconMediumHeight,
};

export const uiFontWeightBold: CSSProperties = {
    fontWeight: 'bold',
};
export const uiFullWidth: CSSProperties = {
    width: '100%',
};

export const uiFullHeight: CSSProperties = {
    height: '100%',
};

export const uiDialogTitle: CSSProperties = {
    fontSize: ThemingParameters.sapFontHeader5Size,
    fontWeight: 'normal',
    margin: '0px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
};
